import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { UpdatedTask, NewTask, TrackLevelCourse, Course as Course_1, TrackLevel, Track, TrackLevelCourse_$reflection, TrackLevel_$reflection, Task_$reflection, Course_$reflection, Track_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, record_type, array_type, option_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { mapIndexed, sortBy, tryFind, append, find, map } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { toArray, bind, defaultArg, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "../Context.jsx";
import { SkeletonItem, Skeleton, Divider, Body2, CounterBadge, Subtitle1, ListItem, List, Caption1, Image, CardHeader, Card, tokens, Spinner, Text as Text$, Option, Dropdown, Switch, DialogSurface, DialogBody, Caption2, DialogActions, Textarea, Input, Field, DialogContent, DialogTitle, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { comparePrimitives, int32ToString, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { WarningFilled, CheckmarkLockRegular, AddRegular, DismissRegular, DeleteRegular, EditRegular } from "@fluentui/react-icons";
import { iterate, take, length, tryHead, empty, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map as map_2, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { Track as Track_1, Course as Course_2, TrackLevelCourse as TrackLevelCourse_1, Task, toastServerError, TrackLevel as TrackLevel_1 } from "../ApiClient.jsx";
import { successToast, errorToast } from "../Toasts.jsx";
import { useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { NewTrackLevelCourse, NewTrackLevel } from "../Shared/Api.jsx";
import { dataFetchFailedView, intToColor } from "../Helpers.jsx";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Int32.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { CreateCourseDialog } from "./CreateCourse.jsx";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";

class Model extends Record {
    constructor(SelectedTrack, Courses, HoveredTask, AllTasks) {
        super();
        this.SelectedTrack = SelectedTrack;
        this.Courses = Courses;
        this.HoveredTask = HoveredTask;
        this.AllTasks = AllTasks;
    }
}

function Model_$reflection() {
    return record_type("Track.TrackBuilder.Model", [], Model, () => [["SelectedTrack", option_type(Track_$reflection())], ["Courses", array_type(Course_$reflection())], ["HoveredTask", option_type(Task_$reflection())], ["AllTasks", array_type(Task_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateSelectedTrack", "UpdateHoveredTask", "UpdatedCourses", "UpdateTrackLevel", "AddTrackLevelCourse", "AddTrackLevelTask", "AddTrackLevelRequiredTask", "DeleteTrackLevelCourse", "DeleteTrackLevelTask", "DeleteTrackLevelRequiredTask", "UpdateAllTasks", "TaskUpdated"];
    }
}

function Msg_$reflection() {
    return union_type("Track.TrackBuilder.Msg", [], Msg, () => [[["Item", option_type(Track_$reflection())]], [["Item", option_type(Task_$reflection())]], [["Item", array_type(Course_$reflection())]], [["Item", TrackLevel_$reflection()]], [["Item", TrackLevelCourse_$reflection()]], [["Item1", TrackLevel_$reflection()], ["Item2", Task_$reflection()]], [["Item1", TrackLevel_$reflection()], ["Item2", Task_$reflection()]], [["Item", TrackLevelCourse_$reflection()]], [["Item1", TrackLevel_$reflection()], ["Item2", Task_$reflection()]], [["Item1", TrackLevel_$reflection()], ["Item2", Task_$reflection()]], [["Item", array_type(Task_$reflection())]], [["Item", Task_$reflection()]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.SelectedTrack, model.Courses, msg.fields[0], model.AllTasks);
        case 2:
            return new Model(model.SelectedTrack, msg.fields[0], model.HoveredTask, model.AllTasks);
        case 3: {
            const trackLevel = msg.fields[0];
            const matchValue = model.SelectedTrack;
            if (matchValue != null) {
                const track_1 = matchValue;
                return new Model(new Track(track_1.Id, track_1.Name, track_1.Description, track_1.Enabled, track_1.ImageUrl, track_1.Inserted, map((tl) => {
                    if (tl.Id === trackLevel.Id) {
                        return trackLevel;
                    }
                    else {
                        return tl;
                    }
                }, track_1.TrackLevels)), model.Courses, model.HoveredTask, model.AllTasks);
            }
            else {
                return model;
            }
        }
        case 4: {
            const trackLevelCourse = msg.fields[0];
            const matchValue_1 = model.SelectedTrack;
            if (matchValue_1 != null) {
                const track_2 = matchValue_1;
                const trackLevel_1 = find((s) => (s.Id === trackLevelCourse.TrackLevelId), track_2.TrackLevels);
                const newTrackLevel = new TrackLevel(trackLevel_1.Id, trackLevel_1.Name, trackLevel_1.Description, trackLevel_1.TrackId, trackLevel_1.Order, trackLevel_1.Inserted, append([trackLevelCourse], trackLevel_1.TrackLevelCourses), trackLevel_1.Tasks, trackLevel_1.RequiredTasks);
                return new Model(new Track(track_2.Id, track_2.Name, track_2.Description, track_2.Enabled, track_2.ImageUrl, track_2.Inserted, map((tl_1) => {
                    if (tl_1.Id === trackLevel_1.Id) {
                        return newTrackLevel;
                    }
                    else {
                        return tl_1;
                    }
                }, track_2.TrackLevels)), model.Courses, model.HoveredTask, model.AllTasks);
            }
            else {
                return model;
            }
        }
        case 5: {
            const trackLevel_2 = msg.fields[0];
            const matchValue_2 = model.SelectedTrack;
            if (matchValue_2 != null) {
                const track_3 = matchValue_2;
                const newTrackLevel_1 = new TrackLevel(trackLevel_2.Id, trackLevel_2.Name, trackLevel_2.Description, trackLevel_2.TrackId, trackLevel_2.Order, trackLevel_2.Inserted, trackLevel_2.TrackLevelCourses, append([msg.fields[1]], trackLevel_2.Tasks), trackLevel_2.RequiredTasks);
                return new Model(new Track(track_3.Id, track_3.Name, track_3.Description, track_3.Enabled, track_3.ImageUrl, track_3.Inserted, map((tl_2) => {
                    if (tl_2.Id === trackLevel_2.Id) {
                        return newTrackLevel_1;
                    }
                    else {
                        return tl_2;
                    }
                }, track_3.TrackLevels)), model.Courses, model.HoveredTask, model.AllTasks);
            }
            else {
                return model;
            }
        }
        case 6: {
            const trackLevel_3 = msg.fields[0];
            const matchValue_3 = model.SelectedTrack;
            if (matchValue_3 != null) {
                const track_4 = matchValue_3;
                const newTrackLevel_2 = new TrackLevel(trackLevel_3.Id, trackLevel_3.Name, trackLevel_3.Description, trackLevel_3.TrackId, trackLevel_3.Order, trackLevel_3.Inserted, trackLevel_3.TrackLevelCourses, trackLevel_3.Tasks, append([msg.fields[1]], trackLevel_3.RequiredTasks));
                return new Model(new Track(track_4.Id, track_4.Name, track_4.Description, track_4.Enabled, track_4.ImageUrl, track_4.Inserted, map((tl_3) => {
                    if (tl_3.Id === trackLevel_3.Id) {
                        return newTrackLevel_2;
                    }
                    else {
                        return tl_3;
                    }
                }, track_4.TrackLevels)), model.Courses, model.HoveredTask, model.AllTasks);
            }
            else {
                return model;
            }
        }
        case 7: {
            const trackLevelCourse_1 = msg.fields[0];
            const matchValue_4 = model.SelectedTrack;
            if (matchValue_4 != null) {
                const track_5 = matchValue_4;
                return new Model(new Track(track_5.Id, track_5.Name, track_5.Description, track_5.Enabled, track_5.ImageUrl, track_5.Inserted, map((tl_4) => {
                    if (tl_4.Id === trackLevelCourse_1.TrackLevelId) {
                        return new TrackLevel(tl_4.Id, tl_4.Name, tl_4.Description, tl_4.TrackId, tl_4.Order, tl_4.Inserted, tl_4.TrackLevelCourses.filter((tl_5) => (tl_5.Id !== trackLevelCourse_1.Id)), tl_4.Tasks, tl_4.RequiredTasks);
                    }
                    else {
                        return tl_4;
                    }
                }, track_5.TrackLevels)), model.Courses, model.HoveredTask, model.AllTasks);
            }
            else {
                return model;
            }
        }
        case 8: {
            const matchValue_5 = model.SelectedTrack;
            if (matchValue_5 != null) {
                const track_6 = matchValue_5;
                return new Model(new Track(track_6.Id, track_6.Name, track_6.Description, track_6.Enabled, track_6.ImageUrl, track_6.Inserted, map((tl_6) => {
                    if (tl_6.Id === msg.fields[0].Id) {
                        return new TrackLevel(tl_6.Id, tl_6.Name, tl_6.Description, tl_6.TrackId, tl_6.Order, tl_6.Inserted, tl_6.TrackLevelCourses, tl_6.Tasks.filter((tl_7) => (tl_7.Id !== msg.fields[1].Id)), tl_6.RequiredTasks);
                    }
                    else {
                        return tl_6;
                    }
                }, track_6.TrackLevels)), model.Courses, model.HoveredTask, model.AllTasks);
            }
            else {
                return model;
            }
        }
        case 9: {
            const matchValue_6 = model.SelectedTrack;
            if (matchValue_6 != null) {
                const track_7 = matchValue_6;
                return new Model(new Track(track_7.Id, track_7.Name, track_7.Description, track_7.Enabled, track_7.ImageUrl, track_7.Inserted, map((tl_8) => {
                    if (tl_8.Id === msg.fields[0].Id) {
                        return new TrackLevel(tl_8.Id, tl_8.Name, tl_8.Description, tl_8.TrackId, tl_8.Order, tl_8.Inserted, tl_8.TrackLevelCourses, tl_8.Tasks, tl_8.RequiredTasks.filter((tl_9) => (tl_9.Id !== msg.fields[1].Id)));
                    }
                    else {
                        return tl_8;
                    }
                }, track_7.TrackLevels)), model.Courses, model.HoveredTask, model.AllTasks);
            }
            else {
                return model;
            }
        }
        case 10:
            return new Model(model.SelectedTrack, model.Courses, model.HoveredTask, msg.fields[0]);
        case 11: {
            const updatedTask = msg.fields[0];
            const replaceTasks = (tasks_1) => map((task_5) => {
                if (task_5.Id === updatedTask.Id) {
                    return updatedTask;
                }
                else {
                    return task_5;
                }
            }, tasks_1);
            const AllTasks = replaceTasks(model.AllTasks);
            return new Model(map_1((track_8) => (new Track(track_8.Id, track_8.Name, track_8.Description, track_8.Enabled, track_8.ImageUrl, track_8.Inserted, map((level) => {
                const Tasks_2 = replaceTasks(level.Tasks);
                const RequiredTasks_1 = replaceTasks(level.RequiredTasks);
                return new TrackLevel(level.Id, level.Name, level.Description, level.TrackId, level.Order, level.Inserted, map((tlc) => {
                    let course;
                    return new TrackLevelCourse(tlc.Id, tlc.TrackLevelId, (course = tlc.Course, new Course_1(course.Id, course.Name, course.Summary, course.Description, course.ImageUrl, course.Inserted, replaceTasks(course.Tasks))), tlc.Order, tlc.Inserted);
                }, level.TrackLevelCourses), Tasks_2, RequiredTasks_1);
            }, track_8.TrackLevels))), model.SelectedTrack), model.Courses, model.HoveredTask, AllTasks);
        }
        default:
            return new Model(msg.fields[0], model.Courses, model.HoveredTask, model.AllTasks);
    }
}

function init() {
    return new Model(undefined, [], undefined, []);
}

function EditTrackLevelDialog(editTrackLevelDialogInputProps) {
    let elems_6, el_4, el_2, el, props_54, props_52, el_6, el_18, elems_2, el_11, el_16, el_29, elems_4, el_27, el_37, elems_5, el_33, el_31, el_35, name, name_2, elemsToUse;
    const dispatch = editTrackLevelDialogInputProps.dispatch;
    const model = editTrackLevelDialogInputProps.model;
    const trackLevel = editTrackLevelDialogInputProps.trackLevel;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const patternInput_2 = reactApi.useState(false);
    const setCtx = useCtx()[1];
    const patternInput_4 = reactApi.useState(trackLevel);
    const setForm = patternInput_4[1];
    const form = patternInput_4[0];
    const resetForm = () => {
        setForm(trackLevel);
    };
    const el_39 = Dialog;
    return createElement(el_39, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_6 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            size: "small",
            appearance: "transparent",
            icon: (el = EditRegular, createElement(el, {
                fontSize: 16,
            })),
        })),
    })), (props_54 = singleton_1((props_52 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Rediger nivå",
    })), (el_18 = DialogContent, createElement(el_18, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_2 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append_1(singleton(["label", "Navn"]), delay(() => append_1(patternInput_1[0] ? append_1(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_1, el_8;
        return singleton(["children", (matchValue_1 = tryHead([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_1, value_1_7) => {
                const v = value_1_7;
                setForm(new TrackLevel(form.Id, v.value, form.Description, form.TrackId, form.Order, form.Inserted, form.TrackLevelCourses, form.Tasks, form.RequiredTasks));
                patternInput_1[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
    }))))))))), (el_16 = Field, createElement(el_16, createObj(toList(delay(() => append_1(singleton(["label", "Beskrivelse"]), delay(() => append_1(patternInput_2[0] ? append_1(singleton(["validationMessage", "Beskrivelse kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_2, el_13;
        return singleton(["children", (matchValue_2 = tryHead([(el_13 = Textarea, createElement(el_13, {
            resize: "both",
            value: form.Description,
            onChange: (_arg_2, value_1_11) => {
                const v_1 = value_1_11;
                setForm(new TrackLevel(form.Id, form.Name, v_1.value, form.TrackId, form.Order, form.Inserted, form.TrackLevelCourses, form.Tasks, form.RequiredTasks));
                patternInput_2[1](isNullOrWhiteSpace(v_1.value));
            },
        }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2)]);
    })))))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_29 = DialogActions, createElement(el_29, createObj(ofArray([["position", "start"], (elems_4 = [(el_27 = Field, createElement(el_27, createObj(toList(delay(() => {
        let el_20;
        return append_1((((trackLevel.Tasks.length > 0) ? true : (trackLevel.RequiredTasks.length > 0)) ? true : (trackLevel.TrackLevelCourses.length > 0)) ? singleton(["validationMessage", (el_20 = Caption2, createElement(el_20, {
            children: "Kan ikke fjerne kursnivå som har oppgaver eller kurs",
        }))]) : empty(), delay(() => {
            let matchValue_3, el_24, el_22;
            return singleton(["children", (matchValue_3 = tryHead([(el_24 = Button, createElement(el_24, {
                disabled: ((trackLevel.Tasks.length > 0) ? true : (trackLevel.RequiredTasks.length > 0)) ? true : (trackLevel.TrackLevelCourses.length > 0),
                icon: (el_22 = DeleteRegular, createElement(el_22, {})),
                iconPosition: "before",
                children: "Slett",
                onClick: (_arg_3) => {
                    let pr_3;
                    const pr_2 = startAsPromise(TrackLevel_1.Delete(trackLevel.Id));
                    pr_3 = (pr_2.then((res_1) => {
                        if (res_1.tag === 1) {
                            if (res_1.fields[0].tag === 1) {
                                errorToast(setCtx, "deleteTrackLevelRelationsExist", "Kunne ikke fjerne nivå", "Nivået brukes fortsatt av andre resurser. Fjern kurs og oppgaver først.", undefined);
                            }
                            else {
                                errorToast(setCtx, "deleteTrackLevelNotFound", "Kunne ikke fjerne nivå", "Fant ikke nivået som prøves å fjernes", undefined);
                            }
                        }
                        else {
                            const matchValue = model.SelectedTrack;
                            if (matchValue != null) {
                                const track = matchValue;
                                dispatch(new Msg(0, [new Track(track.Id, track.Name, track.Description, track.Enabled, track.ImageUrl, track.Inserted, track.TrackLevels.filter((tl) => (tl.Id !== trackLevel.Id)))]));
                            }
                            resetForm();
                            setIsOpen(false);
                            successToast(setCtx, `deleteTask${trackLevel.Id}Success`, "Nivå fjernet", `Nivå ${trackLevel.Name} ble fjernet fra læringsløp`);
                        }
                        return res_1;
                    }));
                    void (pr_3.catch((ex_1) => {
                        toastServerError(setCtx, ex_1);
                    }));
                },
            }))]), (matchValue_3 == null) ? defaultOf() : matchValue_3)]);
        }));
    })))))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))), (el_37 = DialogActions, createElement(el_37, createObj(ofArray([["position", "end"], (elems_5 = [(el_33 = Button, createElement(el_33, {
        icon: (el_31 = DismissRegular, createElement(el_31, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_4) => {
            setIsOpen(false);
            resetForm();
        },
    })), (el_35 = Button, createElement(el_35, {
        appearance: "primary",
        onClick: (_arg_5) => {
            let pr_1;
            const pr = startAsPromise(TrackLevel_1.Update(form));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 1: {
                            errorToast(setCtx, "updateTrackLevelNotFound", "Kunne ikke oppdatere nivå", "Fant ikke nivå å oppdatere", undefined);
                            break;
                        }
                        case 2: {
                            errorToast(setCtx, "updateTrackLevelEmptyFields", "Kunne ikke oppdatere nivå", "En eller flere av feltene var tomme.", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, "updateTrackLevelConflict", "Kunne ikke oppdatere nivå", "Det finnes allerede et nivå med samme navn", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    dispatch(new Msg(3, [form]));
                    resetForm();
                    setIsOpen(false);
                    successToast(setCtx, `updateTask${r.Id}Success`, "Nivå oppdatert", `Nivå ${r.Name} ble oppdatert`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
        disabled: isNullOrWhiteSpace(form.Name) ? true : isNullOrWhiteSpace(form.Description),
        children: "Lagre",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_52)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_54)),
    })))], (elemsToUse = ((length(elems_6) <= 2) ? elems_6 : take(2, elems_6)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function AddNewTaskDialog(addNewTaskDialogInputProps) {
    let elems_5, el_4, el_2, props_49, props_47, el_6, el_23, elems_3, el_11, el_16, el_21, matchValue_3, el_18, el_33, elems_4, el_27, el_25, el_31, el_29, name, name_2, elemsToUse;
    const dispatch = addNewTaskDialogInputProps.dispatch;
    const model = addNewTaskDialogInputProps.model;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const patternInput_2 = reactApi.useState(false);
    const setCtx = useCtx()[1];
    const defaultTaskInitializer = new NewTask("", "", true);
    const patternInput_4 = reactApi.useState(defaultTaskInitializer);
    const setForm = patternInput_4[1];
    const form = patternInput_4[0];
    const resetForm = () => {
        setForm(defaultTaskInitializer);
    };
    const el_35 = Dialog;
    return createElement(el_35, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_5 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, createObj(toList(delay(() => {
            let el;
            return append_1(singleton(["icon", (el = AddRegular, createElement(el, {}))]), delay(() => append_1(singleton(["iconPosition", "before"]), delay(() => append_1(singleton(["appearance", "secondary"]), delay(() => {
                let matchValue;
                return append_1((matchValue = useFeliz_React__React_useResponsive_Static_Z434A9929(), (matchValue.tag === 0) ? singleton(["size", "medium"]) : ((matchValue.tag === 1) ? singleton(["size", "medium"]) : ((matchValue.tag === 2) ? singleton(["size", "medium"]) : singleton(["size", "small"])))), delay(() => singleton(["children", "Oppgave"])));
            }))))));
        }))))),
    })), (props_49 = singleton_1((props_47 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til oppgave",
    })), (el_23 = DialogContent, createElement(el_23, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_3 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append_1(singleton(["label", "Navn"]), delay(() => append_1(patternInput_1[0] ? append_1(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_1, el_8;
        return singleton(["children", (matchValue_1 = tryHead([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_1, value_1_8) => {
                const v = value_1_8;
                setForm(new NewTask(v.value, form.Description, form.VerificationRequired));
                patternInput_1[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
    }))))))))), (el_16 = Field, createElement(el_16, createObj(toList(delay(() => append_1(singleton(["label", "Beskrivelse"]), delay(() => append_1(patternInput_2[0] ? append_1(singleton(["validationMessage", "Beskrivelse kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_2, el_13;
        return singleton(["children", (matchValue_2 = tryHead([(el_13 = Textarea, createElement(el_13, {
            resize: "both",
            value: form.Description,
            onChange: (_arg_2, value_1_12) => {
                const v_1 = value_1_12;
                setForm(new NewTask(form.Name, v_1.value, form.VerificationRequired));
                patternInput_2[1](isNullOrWhiteSpace(v_1.value));
            },
        }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2)]);
    }))))))))), (el_21 = Field, createElement(el_21, {
        label: "Krever kursholder",
        validationState: "none",
        validationMessage: "Velg om kursdeltaker kan godkjenne selv, eller om en kursholder bruker må godkjenne for deltaker",
        children: (matchValue_3 = tryHead([(el_18 = Switch, createElement(el_18, {
            value: form.VerificationRequired,
            onChange: (ev) => {
                setForm(new NewTask(form.Name, form.Description, ev.target.checked));
            },
        }))]), (matchValue_3 == null) ? defaultOf() : matchValue_3),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))), (el_33 = DialogActions, createElement(el_33, createObj(ofArray([["position", "end"], (elems_4 = [(el_27 = Button, createElement(el_27, {
        icon: (el_25 = DismissRegular, createElement(el_25, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_3) => {
            setIsOpen(false);
            resetForm();
        },
    })), (el_31 = Button, createElement(el_31, {
        icon: (el_29 = AddRegular, createElement(el_29, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_4) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Task.Add(form));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    errorToast(setCtx, "addTaskConflict", "Kunne ikke legge til task", "Det finnes allerede en oppgave med dette navnet", undefined);
                }
                else {
                    const r = res.fields[0];
                    dispatch(new Msg(10, [append([r], model.AllTasks)]));
                    successToast(setCtx, `addTask${r.Id}Success`, "Oppgave lagt til", `${r.Name} ble lagt til`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
            resetForm();
        },
        disabled: isNullOrWhiteSpace(form.Name) ? true : isNullOrWhiteSpace(form.Description),
        children: "Legg til",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_47)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_49)),
    })))], (elemsToUse = ((length(elems_5) <= 2) ? elems_5 : take(2, elems_5)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function EditTaskDialog(editTaskDialogInputProps) {
    let elems_9, el, props_53, props_51, el_2, el_28, elems_6, el_38, elems_8, el_30, el_36, name, name_2, elemsToUse;
    const dispatch = editTaskDialogInputProps.dispatch;
    const model = editTaskDialogInputProps.model;
    const renderTrigger = editTaskDialogInputProps.renderTrigger;
    const initialTask = editTaskDialogInputProps.initialTask;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setNameEmpty = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setDescEmpty = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsSaving = patternInput_3[1];
    const isSaving = patternInput_3[0];
    const setCtx = useCtx()[1];
    const emptyForm = new UpdatedTask("", "", true);
    let patternInput_5;
    const initial_4 = defaultArg(map_1((task) => (new UpdatedTask(task.Name, task.Description, task.VerificationRequired)), initialTask), emptyForm);
    patternInput_5 = reactApi.useState(initial_4);
    const setForm = patternInput_5[1];
    const form = patternInput_5[0];
    let patternInput_6;
    const initial_5 = map_1((_arg) => _arg.Id, initialTask);
    patternInput_6 = reactApi.useState(initial_5);
    const setSelectedTaskId = patternInput_6[1];
    const selectedTaskId = patternInput_6[0];
    const hydrateFromTask = (task_1) => {
        setSelectedTaskId(task_1.Id);
        setForm(new UpdatedTask(task_1.Name, task_1.Description, task_1.VerificationRequired));
        setNameEmpty(false);
        setDescEmpty(false);
    };
    const resetState = () => {
        if (initialTask == null) {
            setSelectedTaskId(undefined);
            setForm(emptyForm);
            setNameEmpty(false);
            setDescEmpty(false);
        }
        else {
            hydrateFromTask(initialTask);
        }
    };
    const selectedTask = bind((id) => tryFind((t) => (t.Id === id), model.AllTasks), selectedTaskId);
    const formValid = ((selectedTaskId != null) && !isNullOrWhiteSpace(form.Name)) && !isNullOrWhiteSpace(form.Description);
    let isUnchanged;
    if (selectedTask == null) {
        isUnchanged = true;
    }
    else {
        const task_3 = selectedTask;
        isUnchanged = (((form.Name === task_3.Name) && (form.Description === task_3.Description)) && (form.VerificationRequired === task_3.VerificationRequired));
    }
    const showTaskPicker = initialTask == null;
    const el_40 = Dialog;
    return createElement(el_40, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg_1, value_1_1) => {
        const d = value_1_1;
        setIsOpen(d.open);
        if (d.open) {
            if (initialTask == null) {
            }
            else {
                hydrateFromTask(initialTask);
            }
        }
        else {
            resetState();
        }
    }], (elems_9 = [(el = DialogTrigger, createElement(el, {
        children: renderTrigger(),
    })), (props_53 = singleton_1((props_51 = ofArray([(el_2 = DialogTitle, createElement(el_2, {
        children: "Rediger oppgave",
    })), (el_28 = DialogContent, createElement(el_28, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems_6 = toList(delay(() => {
        let el_11, matchValue_1, el_8, elems_1;
        return append_1(showTaskPicker ? singleton((el_11 = Field, createElement(el_11, {
            label: "Oppgave",
            children: (matchValue_1 = tryHead([(el_8 = Dropdown, createElement(el_8, createObj(ofArray([["placeholder", "Velg oppgave"], ["style", {
                minWidth: 240,
            }], ["onOptionSelect", (_arg_2, value_1_5) => {
                const matchValue = value_1_5.optionValue;
                if (matchValue != null) {
                    const v = matchValue;
                    iterate(hydrateFromTask, toArray(tryFind((task_6) => (int32ToString(task_6.Id) === v), model.AllTasks)));
                }
                else {
                    setSelectedTaskId(undefined);
                    setForm(emptyForm);
                }
            }], (elems_1 = toList(delay(() => map((task_7) => {
                let elems, el_4;
                const el_6 = Option;
                return createElement(el_6, createObj(ofArray([["value", int32ToString(task_7.Id)], ["text", task_7.Name], (elems = [(el_4 = Text$, createElement(el_4, {
                    children: task_7.Name,
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
            }, sortBy((_arg_3) => _arg_3.Name, model.AllTasks, {
                Compare: comparePrimitives,
            })))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
        }))) : empty(), delay(() => {
            let el_16;
            return append_1(singleton((el_16 = Field, createElement(el_16, createObj(toList(delay(() => append_1(singleton(["label", "Navn"]), delay(() => append_1(patternInput_1[0] ? append_1(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                let matchValue_2, el_13;
                return singleton(["children", (matchValue_2 = tryHead([(el_13 = Input, createElement(el_13, {
                    disabled: selectedTask == null,
                    value: form.Name,
                    onChange: (_arg_4, value_1_12) => {
                        const v_1 = value_1_12;
                        setForm(new UpdatedTask(v_1.value, form.Description, form.VerificationRequired));
                        setNameEmpty(isNullOrWhiteSpace(v_1.value));
                    },
                }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2)]);
            })))))))))), delay(() => {
                let el_21;
                return append_1(singleton((el_21 = Field, createElement(el_21, createObj(toList(delay(() => append_1(singleton(["label", "Beskrivelse"]), delay(() => append_1(patternInput_2[0] ? append_1(singleton(["validationMessage", "Beskrivelse kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                    let matchValue_3, el_18;
                    return singleton(["children", (matchValue_3 = tryHead([(el_18 = Textarea, createElement(el_18, {
                        resize: "both",
                        disabled: selectedTask == null,
                        value: form.Description,
                        onChange: (_arg_5, value_1_17) => {
                            const v_2 = value_1_17;
                            setForm(new UpdatedTask(form.Name, v_2.value, form.VerificationRequired));
                            setDescEmpty(isNullOrWhiteSpace(v_2.value));
                        },
                    }))]), (matchValue_3 == null) ? defaultOf() : matchValue_3)]);
                })))))))))), delay(() => {
                    let el_26, matchValue_4, el_23;
                    return singleton((el_26 = Field, createElement(el_26, {
                        label: "Krever kursholder",
                        children: (matchValue_4 = tryHead([(el_23 = Switch, createElement(el_23, {
                            disabled: selectedTask == null,
                            checked: form.VerificationRequired,
                            onChange: (_arg_6, value_1_21) => {
                                setForm(new UpdatedTask(form.Name, form.Description, value_1_21.checked));
                            },
                        }))]), (matchValue_4 == null) ? defaultOf() : matchValue_4),
                    })));
                }));
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))), (el_38 = DialogActions, createElement(el_38, createObj(ofArray([["position", "end"], (elems_8 = [(el_30 = Button, createElement(el_30, {
        children: "Avbryt",
        onClick: (_arg_7) => {
            resetState();
            setIsOpen(false);
        },
    })), (el_36 = Button, createElement(el_36, createObj(toList(delay(() => append_1(singleton(["appearance", "primary"]), delay(() => append_1(singleton(["disabled", (!formValid ? true : isUnchanged) ? true : isSaving]), delay(() => append_1(singleton(["onClick", (_arg_8) => {
        if ((formValid && !isUnchanged) && !isSaving) {
            if (selectedTask != null) {
                const task_4 = selectedTask;
                setIsSaving(true);
                let pr_1;
                const pr = startAsPromise(Task.Update(task_4.Id, form));
                pr_1 = (pr.then((res) => {
                    setIsSaving(false);
                    if (res.tag === 1) {
                        switch (res.fields[0].tag) {
                            case 0: {
                                errorToast(setCtx, "editTaskConflict", "Kunne ikke oppdatere oppgave", "Navnet er allerede i bruk", undefined);
                                break;
                            }
                            case 2: {
                                errorToast(setCtx, "editTaskEmptyFields", "Kunne ikke oppdatere oppgave", "En eller flere av feltene var tomme", undefined);
                                break;
                            }
                            default:
                                errorToast(setCtx, "editTaskNotFound", "Kunne ikke oppdatere oppgave", "Fant ikke oppgaven", undefined);
                        }
                    }
                    else {
                        const updatedTask = res.fields[0];
                        dispatch(new Msg(11, [updatedTask]));
                        successToast(setCtx, `editTask${task_4.Id}Success`, "Oppgave oppdatert", `${updatedTask.Name} ble oppdatert`);
                        setIsOpen(false);
                    }
                    return res;
                }));
                void (pr_1.catch((err) => {
                    setIsSaving(false);
                    toastServerError(setCtx, err);
                }));
            }
        }
    }]), delay(() => {
        let elems_7, el_34, el_32;
        return isSaving ? singleton((elems_7 = [(el_34 = Spinner, createElement(el_34, {
            size: "extra-small",
            label: (el_32 = Text$, createElement(el_32, {
                children: "Lagrer…",
            })),
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])) : singleton(["children", "Lagre"]);
    })))))))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_51)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_53)),
    })))], (elemsToUse = ((length(elems_9) <= 2) ? elems_9 : take(2, elems_9)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function AddTrackLevelDialog(addTrackLevelDialogInputProps) {
    let elems_4, el_4, el_2, el, props_43, props_41, el_6, el_18, elems_2, el_11, el_16, el_28, elems_3, el_22, el_20, el_26, el_24, name, name_2, elemsToUse;
    const dispatch = addTrackLevelDialogInputProps.dispatch;
    const model = addTrackLevelDialogInputProps.model;
    const trackId = addTrackLevelDialogInputProps.trackId;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const patternInput_2 = reactApi.useState(false);
    const setCtx = useCtx()[1];
    let patternInput_4;
    const initial_3 = new NewTrackLevel("", "", trackId);
    patternInput_4 = reactApi.useState(initial_3);
    const setForm = patternInput_4[1];
    const form = patternInput_4[0];
    const resetForm = () => {
        setForm(new NewTrackLevel("", "", trackId));
    };
    const el_30 = Dialog;
    return createElement(el_30, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_4 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            style: {
                display: "flex",
            },
            size: "large",
            appearance: "subtle",
            children: (el = AddRegular, createElement(el, {
                primaryFill: tokens.colorBrandBackgroundInvertedPressed,
                style: {
                    fontSize: 50 + "px",
                },
            })),
        })),
    })), (props_43 = singleton_1((props_41 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til nytt nivå i læringsløpet",
    })), (el_18 = DialogContent, createElement(el_18, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_2 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append_1(singleton(["label", "Navn"]), delay(() => append_1(patternInput_1[0] ? append_1(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_1, el_8;
        return singleton(["children", (matchValue_1 = tryHead([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_1, value_1_8) => {
                const v = value_1_8;
                setForm(new NewTrackLevel(v.value, form.Description, form.TrackId));
                patternInput_1[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue_1 == null) ? defaultOf() : matchValue_1)]);
    }))))))))), (el_16 = Field, createElement(el_16, createObj(toList(delay(() => append_1(singleton(["label", "Beskrivelse"]), delay(() => append_1(patternInput_2[0] ? append_1(singleton(["validationMessage", "Beskrivelse kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue_2, el_13;
        return singleton(["children", (matchValue_2 = tryHead([(el_13 = Textarea, createElement(el_13, {
            resize: "both",
            value: form.Description,
            onChange: (_arg_2, value_1_12) => {
                const v_1 = value_1_12;
                setForm(new NewTrackLevel(form.Name, v_1.value, form.TrackId));
                patternInput_2[1](isNullOrWhiteSpace(v_1.value));
            },
        }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2)]);
    })))))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_28 = DialogActions, createElement(el_28, createObj(ofArray([["position", "end"], (elems_3 = [(el_22 = Button, createElement(el_22, {
        icon: (el_20 = DismissRegular, createElement(el_20, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_3) => {
            setIsOpen(false);
            resetForm();
        },
    })), (el_26 = Button, createElement(el_26, {
        icon: (el_24 = AddRegular, createElement(el_24, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_4) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(TrackLevel_1.Add(form));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 1: {
                            errorToast(setCtx, "addTrackLevelnotFound", "Kunne ikke legge til nivå", "Fant ikke læringsløpet du prøver å nå", undefined);
                            break;
                        }
                        case 2: {
                            errorToast(setCtx, "addTrackLevelEmptyField", "Kunne ikke legge til nivå", "Et eller flere felter var tomme", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, "addTrackLevelConflict", "Kunne ikke legge til nivå", "Det finnes allerede et nivå med dette navnet", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    const matchValue = model.SelectedTrack;
                    if (matchValue != null) {
                        const track = matchValue;
                        dispatch(new Msg(0, [new Track(track.Id, track.Name, track.Description, track.Enabled, track.ImageUrl, track.Inserted, append([r], track.TrackLevels))]));
                    }
                    successToast(setCtx, `addTrackLevel${r.Id}Success`, "Nivå lagt til", `${r.Name} ble lagt til i læringsløpet`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
            resetForm();
        },
        disabled: isNullOrWhiteSpace(form.Name) ? true : isNullOrWhiteSpace(form.Description),
        children: "Legg til",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_41)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_43)),
    })))], (elemsToUse = ((length(elems_4) <= 2) ? elems_4 : take(2, elems_4)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function AddCourseDialog(addCourseDialogInputProps) {
    let elems_9, el_4, el_2, el, el_43, elems_8, props_60, el_6, el_33, elems_6, el_41, elems_7, el_37, el_35, el_39, name, elemsToUse;
    const dispatch = addCourseDialogInputProps.dispatch;
    const model = addCourseDialogInputProps.model;
    const trackLevel = addCourseDialogInputProps.trackLevel;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setSelectedCourse = patternInput_1[1];
    const selectedCourse = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsOpen = patternInput_2[1];
    const el_45 = Dialog;
    return createElement(el_45, createObj(ofArray([["open", patternInput_2[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
        setSelectedCourse(undefined);
    }], (elems_9 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (el_2 = Button, createElement(el_2, {
            appearance: "transparent",
            icon: (el = AddRegular, createElement(el, {})),
            children: "Kurs",
            size: "small",
        })),
    })), (el_43 = DialogSurface, createElement(el_43, createObj(singleton_1((elems_8 = [(props_60 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til nytt kurs i nivået",
    })), (el_33 = DialogContent, createElement(el_33, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 25 + "px ",
    }], (elems_6 = toList(delay(() => {
        let el_15, matchValue_1, el_12, elems_1;
        return append_1(singleton((el_15 = Field, createElement(el_15, {
            label: "Kurs",
            children: (matchValue_1 = tryHead([(el_12 = Dropdown, createElement(el_12, createObj(ofArray([["style", {
                maxWidth: 200,
            }], ["onOptionSelect", (_arg_1, value_1_8) => {
                const matchValue = value_1_8.optionValue;
                if (matchValue != null) {
                    const c = matchValue;
                    setSelectedCourse(tryFind((s_1) => (int32ToString(s_1.Id) === c), model.Courses));
                }
            }], (elems_1 = toList(delay(() => map((c_1) => {
                let elems, el_8;
                const el_10 = Option;
                return createElement(el_10, createObj(ofArray([["disabled", trackLevel.TrackLevelCourses.some((t) => (t.Course.Id === c_1.Id))], ["value", int32ToString(c_1.Id)], ["text", c_1.Name], (elems = [(el_8 = Text$, createElement(el_8, {
                    children: c_1.Name,
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
            }, sortBy((_arg_2) => _arg_2.Name, model.Courses, {
                Compare: comparePrimitives,
            })))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
        }))), delay(() => {
            let el_31, elems_5, el_21, el_17, el_19, el_29, elems_4;
            const matchValue_2 = selectedCourse;
            if (matchValue_2 != null) {
                const c_2 = matchValue_2;
                return singleton((el_31 = Card, createElement(el_31, createObj(ofArray([["style", {
                    minHeight: 100,
                }], ["appearance", "filled-alternative"], (elems_5 = [(el_21 = CardHeader, createElement(el_21, {
                    image: (el_17 = Image, createElement(el_17, {
                        style: {
                            height: 48,
                        },
                        src: defaultArg(c_2.ImageUrl, ""),
                    })),
                    header: c_2.Name,
                    description: (el_19 = Caption1, createElement(el_19, {
                        children: c_2.Summary,
                    })),
                })), (el_29 = List, createElement(el_29, createObj(singleton_1((elems_4 = toList(delay(() => map((require) => {
                    let elems_3, el_23, el_25;
                    const el_27 = ListItem;
                    return createElement(el_27, createObj(ofArray([["style", {
                        alignItems: "center",
                        display: "flex",
                        gap: 5 + "px ",
                    }], (elems_3 = [(el_23 = CheckmarkLockRegular, createElement(el_23, {
                        primaryFill: intToColor(require.Id),
                    })), (el_25 = Caption2, createElement(el_25, {
                        children: require.Name,
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])));
                }, c_2.Tasks))), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])))));
            }
            else {
                return empty();
            }
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))), (el_41 = DialogActions, createElement(el_41, createObj(ofArray([["position", "end"], (elems_7 = [(el_37 = DialogTrigger, createElement(el_37, {
        disableButtonEnhancement: true,
        children: (el_35 = Button, createElement(el_35, {
            appearance: "secondary",
            children: "Avbryt",
        })),
    })), (el_39 = Button, createElement(el_39, createObj(toList(delay(() => append_1(singleton(["disabled", selectedCourse == null]), delay(() => append_1(singleton(["appearance", "primary"]), delay(() => append_1(singleton(["children", "Legg til"]), delay(() => {
        const matchValue_3 = selectedCourse;
        if (matchValue_3 != null) {
            const c_3 = matchValue_3;
            return singleton(["onClick", (_arg_3) => {
                let pr_1;
                const pr = startAsPromise(TrackLevelCourse_1.Add(new NewTrackLevelCourse(trackLevel.Id, c_3.Id)));
                pr_1 = (pr.then((res) => {
                    if (res.tag === 1) {
                        if (res.fields[0].tag === 1) {
                            errorToast(setCtx, "addTLCError", "Kunne ikke legge til kurs", "Fant ikke resurser å legge til", undefined);
                        }
                        else {
                            errorToast(setCtx, "addTLCError", "Kunne ikke legge til kurs", "Kurset er allerede lagt til", undefined);
                        }
                    }
                    else {
                        dispatch(new Msg(4, [res.fields[0]]));
                        setIsOpen(false);
                        successToast(setCtx, `addTLC${c_3.Id}-${trackLevel.Id}`, "Nytt kurs lagt til", `Kurs ${c_3.Name} ble lagt til  nivå ${trackLevel.Name}`);
                    }
                    return res;
                }));
                void (pr_1.catch((ex) => {
                    toastServerError(setCtx, ex);
                }));
            }]);
        }
        else {
            return empty();
        }
    })))))))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_60)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])))))], (elemsToUse = ((length(elems_9) <= 2) ? elems_9 : take(2, elems_9)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function DeleteTrackLevelCourseDialog(deleteTrackLevelCourseDialogInputProps) {
    let elems_4, el_4, el_2, el, el_26, elems_3, props_38, el_6, el_16, elems_1, el_14, elems, el_8, el_10, el_12, value_38, el_24, elems_2, el_20, el_18, el_22, name, elemsToUse;
    const dispatch = deleteTrackLevelCourseDialogInputProps.dispatch;
    const _model = deleteTrackLevelCourseDialogInputProps._model;
    const trackLevelCourse = deleteTrackLevelCourseDialogInputProps.trackLevelCourse;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const el_28 = Dialog;
    return createElement(el_28, createObj(ofArray([["open", patternInput_1[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_4 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (el_2 = Button, createElement(el_2, {
            size: "small",
            appearance: "transparent",
            icon: (el = DismissRegular, createElement(el, {
                fontSize: 16,
            })),
        })),
    })), (el_26 = DialogSurface, createElement(el_26, createObj(singleton_1((elems_3 = [(props_38 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Fjern kurs fra nivå",
    })), (el_16 = DialogContent, createElement(el_16, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 25 + "px ",
    }], (elems_1 = [(el_14 = DialogContent, createElement(el_14, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_8 = WarningFilled, createElement(el_8, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_10 = Subtitle1, createElement(el_10, {
        children: `${trackLevelCourse.Course.Name}`,
    })), (el_12 = Text$, createElement(el_12, createObj(ofArray([(value_38 = "Er du sikker på at du vil fjerne dette kurset fra nivået? Det vil ikke være mulig å angre denne handlingen.", ["children", value_38]), ["align", "center"]]))))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_24 = DialogActions, createElement(el_24, createObj(ofArray([["position", "end"], (elems_2 = [(el_20 = DialogTrigger, createElement(el_20, {
        disableButtonEnhancement: true,
        children: (el_18 = Button, createElement(el_18, {
            appearance: "secondary",
            children: "Avbryt",
        })),
    })), (el_22 = Button, createElement(el_22, {
        appearance: "primary",
        children: "Fjern",
        onClick: (_arg_1) => {
            let pr_1;
            const pr = startAsPromise(TrackLevelCourse_1.Delete(trackLevelCourse.Id));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    if (res.fields[0].tag === 0) {
                        errorToast(setCtx, "deleteTLCError", "Kunne ikke fjernet kurs", "Fant ikke resurs å fjerne", undefined);
                    }
                    else {
                        errorToast(setCtx, "deleteTLCError", "Kunne ikke fjernet kurs", "Kurset er fortsatt i bruk", undefined);
                    }
                }
                else {
                    setIsOpen(false);
                    successToast(setCtx, `deleteTLC-${trackLevelCourse.Id}`, "Kurs fjernet", `${trackLevelCourse.Course.Name} ble fjernet`);
                    dispatch(new Msg(7, [trackLevelCourse]));
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_38)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])))))], (elemsToUse = ((length(elems_4) <= 2) ? elems_4 : take(2, elems_4)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function DeleteTrackLevelTaskDialog(deleteTrackLevelTaskDialogInputProps) {
    let elems_4, el_4, el_2, el, el_26, elems_3, props_38, el_6, el_16, elems_1, el_14, elems, el_8, el_10, el_12, value_38, el_24, elems_2, el_20, el_18, el_22, name, elemsToUse;
    const dispatch = deleteTrackLevelTaskDialogInputProps.dispatch;
    const _model = deleteTrackLevelTaskDialogInputProps._model;
    const trackLevelTask = deleteTrackLevelTaskDialogInputProps.trackLevelTask;
    const trackLevel = deleteTrackLevelTaskDialogInputProps.trackLevel;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const el_28 = Dialog;
    return createElement(el_28, createObj(ofArray([["open", patternInput_1[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_4 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (el_2 = Button, createElement(el_2, {
            size: "small",
            appearance: "transparent",
            icon: (el = DismissRegular, createElement(el, {
                fontSize: 16,
            })),
        })),
    })), (el_26 = DialogSurface, createElement(el_26, createObj(singleton_1((elems_3 = [(props_38 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Fjern oppgave fra nivå",
    })), (el_16 = DialogContent, createElement(el_16, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 25 + "px ",
    }], (elems_1 = [(el_14 = DialogContent, createElement(el_14, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = [(el_8 = WarningFilled, createElement(el_8, {
        primaryFill: tokens.colorStatusWarningForeground1,
        fontSize: 48,
    })), (el_10 = Subtitle1, createElement(el_10, {
        children: `${trackLevelTask.Name}`,
    })), (el_12 = Text$, createElement(el_12, createObj(ofArray([(value_38 = "Er du sikker på at du vil fjerne denne oppgaven fra nivået? Det vil ikke være mulig å angre denne handlingen.", ["children", value_38]), ["align", "center"]]))))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_24 = DialogActions, createElement(el_24, createObj(ofArray([["position", "end"], (elems_2 = [(el_20 = DialogTrigger, createElement(el_20, {
        disableButtonEnhancement: true,
        children: (el_18 = Button, createElement(el_18, {
            appearance: "secondary",
            children: "Avbryt",
        })),
    })), (el_22 = Button, createElement(el_22, {
        appearance: "primary",
        children: "Fjern",
        onClick: (_arg_1) => {
            let pr_1;
            const pr = startAsPromise(TrackLevel_1.DeleteTask([trackLevel.Id, trackLevelTask.Id]));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    errorToast(setCtx, "deleteTLCError", "Kunne ikke fjerne oppgave", "Fant ikke resurs å fjerne", undefined);
                }
                else {
                    setIsOpen(false);
                    successToast(setCtx, `deleteTLT-${trackLevel.Id}`, "Oppdate fjernet", `${trackLevelTask.Name} ble fjernet`);
                    dispatch(new Msg(8, [trackLevel, trackLevelTask]));
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_38)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])))))], (elemsToUse = ((length(elems_4) <= 2) ? elems_4 : take(2, elems_4)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function AddTrackLevelTaskDialog(addTrackLevelTaskDialogInputProps) {
    let elems_7, el_4, el_2, el, el_35, elems_6, props_49, el_6, el_25, elems_4, el_33, elems_5, el_29, el_27, el_31, name, elemsToUse;
    const dispatch = addTrackLevelTaskDialogInputProps.dispatch;
    const model = addTrackLevelTaskDialogInputProps.model;
    const trackLevel = addTrackLevelTaskDialogInputProps.trackLevel;
    const patternInput = reactApi.useState(undefined);
    const setSelectedTask = patternInput[1];
    const selectedTask = patternInput[0];
    const setCtx = useCtx()[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsOpen = patternInput_2[1];
    const el_37 = Dialog;
    return createElement(el_37, createObj(ofArray([["open", patternInput_2[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
        setSelectedTask(undefined);
    }], (elems_7 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (el_2 = Button, createElement(el_2, {
            appearance: "transparent",
            icon: (el = AddRegular, createElement(el, {})),
            children: "Oppgave",
            size: "small",
        })),
    })), (el_35 = DialogSurface, createElement(el_35, createObj(singleton_1((elems_6 = [(props_49 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til ny oppgave i nivået",
    })), (el_25 = DialogContent, createElement(el_25, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 25 + "px ",
    }], (elems_4 = toList(delay(() => {
        let el_15, matchValue_1, el_12, elems_1;
        return append_1(singleton((el_15 = Field, createElement(el_15, {
            label: "Oppgaver",
            children: (matchValue_1 = tryHead([(el_12 = Dropdown, createElement(el_12, createObj(ofArray([["style", {
                maxWidth: 200,
            }], ["onOptionSelect", (_arg_1, value_1_8) => {
                const matchValue = value_1_8.optionValue;
                if (matchValue != null) {
                    const c = matchValue;
                    setSelectedTask(tryFind((s_1) => (int32ToString(s_1.Id) === c), model.AllTasks));
                }
            }], (elems_1 = toList(delay(() => map((c_1) => {
                let elems, el_8;
                const el_10 = Option;
                return createElement(el_10, createObj(ofArray([["disabled", trackLevel.Tasks.some((t) => (t.Id === c_1.Id))], ["value", int32ToString(c_1.Id)], ["text", c_1.Name], (elems = [(el_8 = Text$, createElement(el_8, {
                    children: c_1.Name,
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
            }, sortBy((_arg_2) => _arg_2.Name, model.AllTasks, {
                Compare: comparePrimitives,
            })))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
        }))), delay(() => {
            let el_23, elems_3, el_21, el_17, el_19;
            const matchValue_2 = selectedTask;
            if (matchValue_2 != null) {
                const c_2 = matchValue_2;
                return singleton((el_23 = Card, createElement(el_23, createObj(ofArray([["appearance", "filled-alternative"], (elems_3 = [(el_21 = CardHeader, createElement(el_21, {
                    header: c_2.Name,
                    description: (el_17 = Caption1, createElement(el_17, {
                        children: c_2.Description,
                    })),
                    image: (el_19 = CheckmarkLockRegular, createElement(el_19, {
                        fontSize: 28,
                        primaryFill: tokens.colorBrandForeground1,
                    })),
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))));
            }
            else {
                return empty();
            }
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))), (el_33 = DialogActions, createElement(el_33, createObj(ofArray([["position", "end"], (elems_5 = [(el_29 = DialogTrigger, createElement(el_29, {
        disableButtonEnhancement: true,
        children: (el_27 = Button, createElement(el_27, {
            appearance: "secondary",
            children: "Avbryt",
        })),
    })), (el_31 = Button, createElement(el_31, createObj(toList(delay(() => append_1(singleton(["disabled", selectedTask == null]), delay(() => append_1(singleton(["appearance", "primary"]), delay(() => append_1(singleton(["children", "Legg til"]), delay(() => {
        const matchValue_3 = selectedTask;
        if (matchValue_3 != null) {
            const t_1 = matchValue_3;
            return singleton(["onClick", (_arg_3) => {
                let pr_1;
                const pr = startAsPromise(TrackLevel_1.AddTask([trackLevel.Id, t_1.Id]));
                pr_1 = (pr.then((res) => {
                    if (res.tag === 1) {
                        if (res.fields[0].tag === 1) {
                            errorToast(setCtx, `addtrackLevelTaskNotFound-${t_1.Id}-${trackLevel.Id}`, "Kunne ikke legge til oppgave", "Fant ikke resurser å legge til", undefined);
                        }
                        else {
                            errorToast(setCtx, `addtrackLevelTaskConflict-${t_1.Id}-${trackLevel.Id}`, "Kunne ikke legge til oppgave", "Oppgaven er allerede lagt til", undefined);
                        }
                    }
                    else {
                        const task = res.fields[0];
                        dispatch(new Msg(5, [trackLevel, task]));
                        setIsOpen(false);
                        successToast(setCtx, `addtrackLevelTask-${task.Id}-${trackLevel.Id}`, "Ny oppgave lagt til", `Oppgave ${task.Name} ble lagt til i nivå ${trackLevel.Name}`);
                    }
                    return res;
                }));
                void (pr_1.catch((ex) => {
                    toastServerError(setCtx, ex);
                }));
            }]);
        }
        else {
            return empty();
        }
    })))))))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_49)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])))))], (elemsToUse = ((length(elems_7) <= 2) ? elems_7 : take(2, elems_7)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function AddTrackLevelRequiredTaskDialog(addTrackLevelRequiredTaskDialogInputProps) {
    let elems_7, el_4, el_2, el, el_35, elems_6, props_49, el_6, el_25, elems_4, el_33, elems_5, el_29, el_27, el_31, name, elemsToUse;
    const dispatch = addTrackLevelRequiredTaskDialogInputProps.dispatch;
    const model = addTrackLevelRequiredTaskDialogInputProps.model;
    const trackLevel = addTrackLevelRequiredTaskDialogInputProps.trackLevel;
    const patternInput = reactApi.useState(undefined);
    const setSelectedTask = patternInput[1];
    const selectedTask = patternInput[0];
    const setCtx = useCtx()[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsOpen = patternInput_2[1];
    const el_37 = Dialog;
    return createElement(el_37, createObj(ofArray([["open", patternInput_2[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
        setSelectedTask(undefined);
    }], (elems_7 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (el_2 = Button, createElement(el_2, {
            size: "small",
            style: {
                padding: 0,
            },
            appearance: "transparent",
            icon: (el = AddRegular, createElement(el, {
                primaryFill: tokens.colorBrandForeground1,
                style: {
                    fontSize: 15 + "px",
                    padding: 0,
                    margin: 0,
                },
            })),
        })),
    })), (el_35 = DialogSurface, createElement(el_35, createObj(singleton_1((elems_6 = [(props_49 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til ny oppgave som betingelse i nivået",
    })), (el_25 = DialogContent, createElement(el_25, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 25 + "px ",
    }], (elems_4 = toList(delay(() => {
        let el_15, matchValue_1, el_12, elems_1;
        return append_1(singleton((el_15 = Field, createElement(el_15, {
            label: "Oppgaver",
            children: (matchValue_1 = tryHead([(el_12 = Dropdown, createElement(el_12, createObj(ofArray([["style", {
                maxWidth: 200,
            }], ["onOptionSelect", (_arg_1, value_1_8) => {
                const matchValue = value_1_8.optionValue;
                if (matchValue != null) {
                    const c = matchValue;
                    setSelectedTask(tryFind((s_1) => (int32ToString(s_1.Id) === c), model.AllTasks));
                }
            }], (elems_1 = toList(delay(() => map((c_1) => {
                let elems, el_8;
                const el_10 = Option;
                return createElement(el_10, createObj(ofArray([["disabled", trackLevel.RequiredTasks.some((t) => (t.Id === c_1.Id))], ["value", int32ToString(c_1.Id)], ["text", c_1.Name], (elems = [(el_8 = Text$, createElement(el_8, {
                    children: c_1.Name,
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
            }, sortBy((_arg_2) => _arg_2.Name, model.AllTasks, {
                Compare: comparePrimitives,
            })))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
        }))), delay(() => {
            let el_23, elems_3, el_21, el_17, el_19;
            const matchValue_2 = selectedTask;
            if (matchValue_2 != null) {
                const c_2 = matchValue_2;
                return singleton((el_23 = Card, createElement(el_23, createObj(ofArray([["appearance", "filled-alternative"], (elems_3 = [(el_21 = CardHeader, createElement(el_21, {
                    header: c_2.Name,
                    description: (el_17 = Caption1, createElement(el_17, {
                        children: c_2.Description,
                    })),
                    image: (el_19 = CheckmarkLockRegular, createElement(el_19, {
                        fontSize: 28,
                        primaryFill: tokens.colorBrandForeground1,
                    })),
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))));
            }
            else {
                return empty();
            }
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])))), (el_33 = DialogActions, createElement(el_33, createObj(ofArray([["position", "end"], (elems_5 = [(el_29 = DialogTrigger, createElement(el_29, {
        disableButtonEnhancement: true,
        children: (el_27 = Button, createElement(el_27, {
            appearance: "secondary",
            children: "Avbryt",
        })),
    })), (el_31 = Button, createElement(el_31, createObj(toList(delay(() => append_1(singleton(["disabled", selectedTask == null]), delay(() => append_1(singleton(["appearance", "primary"]), delay(() => append_1(singleton(["children", "Legg til"]), delay(() => {
        const matchValue_3 = selectedTask;
        if (matchValue_3 != null) {
            const t_1 = matchValue_3;
            return singleton(["onClick", (_arg_3) => {
                let pr_1;
                const pr = startAsPromise(TrackLevel_1.AddRequiredTask([trackLevel.Id, t_1.Id]));
                pr_1 = (pr.then((res) => {
                    if (res.tag === 1) {
                        if (res.fields[0].tag === 1) {
                            errorToast(setCtx, `addtrackLevelTaskNotFound-${t_1.Id}-${trackLevel.Id}`, "Kunne ikke legge til oppgave", "Fant ikke resurser å legge til", undefined);
                        }
                        else {
                            errorToast(setCtx, `addtrackLevelTaskConflict-${t_1.Id}-${trackLevel.Id}`, "Kunne ikke legge til kurs", "Oppgaven er allerede lagt til", undefined);
                        }
                    }
                    else {
                        const task = res.fields[0];
                        dispatch(new Msg(6, [trackLevel, task]));
                        setIsOpen(false);
                        successToast(setCtx, `addtrackLevelTask-${task.Id}-${trackLevel.Id}`, "Ny oppgave lagt til", `Oppgave ${task.Name} ble lagt til i nivå ${trackLevel.Name}`);
                    }
                    return res;
                }));
                void (pr_1.catch((ex) => {
                    toastServerError(setCtx, ex);
                }));
            }]);
        }
        else {
            return empty();
        }
    })))))))))))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_49)),
    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])))))], (elemsToUse = ((length(elems_7) <= 2) ? elems_7 : take(2, elems_7)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function reorderOnHover(newTlc, currentLevel, draggedId, dispatch) {
    const oldTlc = find((tlc) => (tlc.Id === draggedId), currentLevel.TrackLevelCourses);
    return dispatch(new Msg(3, [new TrackLevel(currentLevel.Id, currentLevel.Name, currentLevel.Description, currentLevel.TrackId, currentLevel.Order, currentLevel.Inserted, map((x) => {
        if (oldTlc.Order < newTlc.Order) {
            if (x.Id === oldTlc.Id) {
                return new TrackLevelCourse(x.Id, x.TrackLevelId, x.Course, newTlc.Order, x.Inserted);
            }
            else if ((x.Order <= newTlc.Order) && (x.Order > oldTlc.Order)) {
                return new TrackLevelCourse(x.Id, x.TrackLevelId, x.Course, x.Order - 1, x.Inserted);
            }
            else {
                return x;
            }
        }
        else if (x.Id === oldTlc.Id) {
            return new TrackLevelCourse(x.Id, x.TrackLevelId, x.Course, newTlc.Order, x.Inserted);
        }
        else if ((x.Order >= newTlc.Order) && (x.Order < oldTlc.Order)) {
            return new TrackLevelCourse(x.Id, x.TrackLevelId, x.Course, x.Order + 1, x.Inserted);
        }
        else {
            return x;
        }
    }, currentLevel.TrackLevelCourses), currentLevel.Tasks, currentLevel.RequiredTasks)]));
}

function TrackLevelCourseCard(trackLevelCourseCardInputProps) {
    let elems_2, el_5, el_1, el_3, el_13, elems_1;
    const dispatch = trackLevelCourseCardInputProps.dispatch;
    const model = trackLevelCourseCardInputProps.model;
    const trackLevel = trackLevelCourseCardInputProps.trackLevel;
    const tlc = trackLevelCourseCardInputProps.tlc;
    const setCtx = useCtx()[1];
    const el_15 = Card;
    return createElement(el_15, createObj(ofArray([["key", `track_level-${tlc.Id}`], ["draggable", true], ["onDrop", (e) => {
        e.preventDefault();
        const draggedId = parse(e.dataTransfer.getData("text/plain"), 511, false, 32) | 0;
        const draggedItem = find((tlc_1) => (tlc_1.Id === draggedId), trackLevel.TrackLevelCourses);
        let pr_1;
        const pr = startAsPromise(TrackLevelCourse_1.UpdateOrder([draggedItem.Id, draggedItem.Order]));
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "updateTrackLevelCourseOrderError", "Kunne ikke oppdatere kurs", "Noe gikk galt", undefined);
            }
            return res;
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
    }], ["onDragStart", (e_1) => {
        e_1.dataTransfer.setData("text/plain", int32ToString(tlc.Id));
    }], ["onDragOver", (e_2) => {
        e_2.preventDefault();
        const el = e_2.currentTarget;
        const rect = el.getBoundingClientRect();
        const topTrigger = rect.top + (rect.height * 0.8);
        const bottomTrigger = rect.bottom + (rect.height * 0.2);
        const draggedId_1 = parse(e_2.dataTransfer.getData("text/plain"), 511, false, 32) | 0;
        const draggedItem_1 = tryFind((s) => (s.Id === draggedId_1), trackLevel.TrackLevelCourses);
        if (draggedItem_1 != null) {
            if (draggedItem_1.Order < tlc.Order) {
                if (e_2.clientY > topTrigger) {
                    reorderOnHover(tlc, trackLevel, draggedId_1, dispatch);
                }
            }
            else if (e_2.clientY < bottomTrigger) {
                reorderOnHover(tlc, trackLevel, draggedId_1, dispatch);
            }
        }
    }], ["style", {
        minHeight: 100,
    }], ["appearance", "filled-alternative"], (elems_2 = [(el_5 = CardHeader, createElement(el_5, {
        image: (el_1 = Image, createElement(el_1, {
            style: {
                height: 48,
            },
            src: defaultArg(tlc.Course.ImageUrl, ""),
        })),
        header: tlc.Course.Name,
        description: (el_3 = Caption1, createElement(el_3, {
            children: tlc.Course.Summary,
        })),
        action: createElement(DeleteTrackLevelCourseDialog, {
            trackLevelCourse: tlc,
            _model: model,
            dispatch: dispatch,
        }),
    })), (el_13 = List, createElement(el_13, createObj(singleton_1((elems_1 = toList(delay(() => map((require) => {
        let elems, el_7, el_9;
        const el_11 = ListItem;
        return createElement(el_11, createObj(ofArray([["style", {
            alignItems: "center",
            display: "flex",
            gap: 5 + "px ",
        }], ["onMouseEnter", (_arg) => {
            dispatch(new Msg(1, [require]));
        }], ["onMouseLeave", (_arg_1) => {
            dispatch(new Msg(1, [undefined]));
        }], (elems = [(el_7 = CheckmarkLockRegular, createElement(el_7, createObj(toList(delay(() => {
            const matchValue = model.HoveredTask;
            let matchResult, hovered_1;
            if (matchValue != null) {
                if (matchValue.Id === require.Id) {
                    matchResult = 0;
                    hovered_1 = matchValue;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton(["primaryFill", tokens.colorPaletteYellowBorder2]);
                default:
                    return singleton(["primaryFill", intToColor(require.Id)]);
            }
        }))))), (el_9 = Caption2, createElement(el_9, {
            children: require.Name,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }, tlc.Course.Tasks))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
}

function TrackLevelView(trackLevelViewInputProps) {
    let elems_10, elems_1, elems, el, el_2, children, el_4, elems_9;
    const dispatch = trackLevelViewInputProps.dispatch;
    const model = trackLevelViewInputProps.model;
    const _track = trackLevelViewInputProps._track;
    const trackLevel = trackLevelViewInputProps.trackLevel;
    const order = trackLevelViewInputProps.order;
    const setCtx = useCtx()[1];
    const el_40 = Card;
    return createElement(el_40, createObj(ofArray([["key", `track_level-${trackLevel.Id}`], ["draggable", false], ["appearance", "filled"], ["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "column"]), delay(() => {
        let matchValue;
        return append_1((matchValue = useFeliz_React__React_useResponsive_Static_Z434A9929(), (matchValue.tag === 0) ? singleton(["flexGrow", 1]) : ((matchValue.tag === 1) ? singleton(["flexGrow", 1]) : append_1(singleton(["minWidth", 400]), delay(() => singleton(["maxWidth", 400]))))), delay(() => singleton(["minHeight", 150])));
    })))))))], (elems_10 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 5,
        gap: 5 + "px ",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 5 + "px ",
        alignItems: "center",
    }], (elems = [(el = CounterBadge, createElement(el, {
        children: order,
    })), (el_2 = Body2, createElement(el_2, {
        children: trackLevel.Name,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), (children = singleton_1(createElement(EditTrackLevelDialog, {
        trackLevel: trackLevel,
        model: model,
        dispatch: dispatch,
    })), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_4 = Caption1, createElement(el_4, {
        children: trackLevel.Description,
    })), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        padding: ((((((0 + "px ") + 0) + "px ") + 10) + "px ") + 0) + "px",
        gap: 5 + "px ",
    }], (elems_9 = toList(delay(() => {
        let elems_2, el_6;
        return append_1(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
        }], (elems_2 = [(el_6 = Caption1, createElement(el_6, {
            children: "Betingelser",
        })), createElement(AddTrackLevelRequiredTaskDialog, {
            trackLevel: trackLevel,
            model: model,
            dispatch: dispatch,
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let el_20, elems_5;
            return append_1(singleton((el_20 = List, createElement(el_20, createObj(singleton_1((elems_5 = toList(delay(() => map((require) => {
                let elems_4, el_8, el_10, elems_3, el_16;
                const el_18 = ListItem;
                return createElement(el_18, createObj(ofArray([["style", {
                    alignItems: "center",
                    display: "flex",
                    gap: 5 + "px ",
                }], ["onMouseEnter", (_arg) => {
                    dispatch(new Msg(1, [require]));
                }], ["onMouseLeave", (_arg_1) => {
                    dispatch(new Msg(1, [undefined]));
                }], (elems_4 = [(el_8 = CheckmarkLockRegular, createElement(el_8, createObj(toList(delay(() => {
                    const matchValue_1 = model.HoveredTask;
                    let matchResult, hovered_1;
                    if (matchValue_1 != null) {
                        if (matchValue_1.Id === require.Id) {
                            matchResult = 0;
                            hovered_1 = matchValue_1;
                        }
                        else {
                            matchResult = 1;
                        }
                    }
                    else {
                        matchResult = 1;
                    }
                    switch (matchResult) {
                        case 0:
                            return singleton(["primaryFill", tokens.colorPaletteYellowBorder2]);
                        default:
                            return singleton(["primaryFill", intToColor(require.Id)]);
                    }
                }))))), (el_10 = Caption2, createElement(el_10, {
                    children: require.Name,
                })), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 5 + "px ",
                    marginLeft: 8,
                }], (elems_3 = [createElement(EditTaskDialog, {
                    initialTask: require,
                    renderTrigger: () => {
                        let el_12;
                        const el_14 = Button;
                        return createElement(el_14, {
                            size: "small",
                            appearance: "transparent",
                            icon: (el_12 = EditRegular, createElement(el_12, {
                                fontSize: 16,
                            })),
                        });
                    },
                    model: model,
                    dispatch: dispatch,
                }), (el_16 = DismissRegular, createElement(el_16, {
                    onClick: (_arg_2) => {
                        let pr_1;
                        const pr = startAsPromise(TrackLevel_1.DeleteRequiredTask([trackLevel.Id, require.Id]));
                        pr_1 = (pr.then((res) => {
                            if (res.tag === 1) {
                                errorToast(setCtx, "deleteTLCError", "Kunne ikke fjerne oppgave", "Fant ikke resurs å fjerne", undefined);
                            }
                            else {
                                successToast(setCtx, `deleteTLTTask-${trackLevel.Id}`, "Oppgave fjernet", `${require.Name} ble fjernet fra nivå ${trackLevel.Name}`);
                                dispatch(new Msg(9, [trackLevel, require]));
                            }
                            return res;
                        }));
                        void (pr_1.catch((ex) => {
                            toastServerError(setCtx, ex);
                        }));
                    },
                    primaryFill: tokens.colorBrandForeground1,
                    style: {
                        fontSize: 10 + "px",
                        cursor: "pointer",
                    },
                }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])])));
            }, trackLevel.RequiredTasks))), ["children", reactApi_1.Children.toArray(Array.from(elems_5))])))))), delay(() => {
                let children_2, el_22;
                return append_1(singleton((children_2 = singleton_1((el_22 = Divider, createElement(el_22, {
                    appearance: "subtle",
                }))), createElement("div", {
                    children: reactApi.Children.toArray(Array.from(children_2)),
                }))), delay(() => {
                    let el_24;
                    return append_1(singleton((el_24 = Caption1, createElement(el_24, {
                        children: "Kurs",
                    }))), delay(() => {
                        let el_26;
                        return append_1((trackLevel.TrackLevelCourses.length === 0) ? singleton((el_26 = Caption2, createElement(el_26, {
                            children: "Ingen kurs",
                        }))) : empty(), delay(() => append_1(map((course) => createElement(TrackLevelCourseCard, {
                            tlc: course,
                            trackLevel: trackLevel,
                            model: model,
                            dispatch: dispatch,
                        }), sortBy((_arg_3) => _arg_3.Order, trackLevel.TrackLevelCourses, {
                            Compare: comparePrimitives,
                        })), delay(() => append_1(map((require_1) => {
                            let elems_7, el_36, el_28, el_30, elems_6;
                            const el_38 = Card;
                            return createElement(el_38, createObj(ofArray([["appearance", "filled-alternative"], ["onMouseEnter", (_arg_4) => {
                                dispatch(new Msg(1, [require_1]));
                            }], ["onMouseLeave", (_arg_5) => {
                                dispatch(new Msg(1, [undefined]));
                            }], (elems_7 = [(el_36 = CardHeader, createElement(el_36, {
                                header: (el_28 = Caption2, createElement(el_28, {
                                    children: require_1.Name,
                                })),
                                image: (el_30 = CheckmarkLockRegular, createElement(el_30, createObj(toList(delay(() => append_1(singleton(["fontSize", 20]), delay(() => {
                                    const matchValue_2 = model.HoveredTask;
                                    let matchResult_1, hovered_3;
                                    if (matchValue_2 != null) {
                                        if (matchValue_2.Id === require_1.Id) {
                                            matchResult_1 = 0;
                                            hovered_3 = matchValue_2;
                                        }
                                        else {
                                            matchResult_1 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                    switch (matchResult_1) {
                                        case 0:
                                            return singleton(["primaryFill", tokens.colorPaletteYellowBorder2]);
                                        default:
                                            return singleton(["primaryFill", intToColor(require_1.Id)]);
                                    }
                                }))))))),
                                action: createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5 + "px ",
                                }], (elems_6 = [createElement(EditTaskDialog, {
                                    initialTask: require_1,
                                    renderTrigger: () => {
                                        let el_32;
                                        const el_34 = Button;
                                        return createElement(el_34, {
                                            size: "small",
                                            appearance: "transparent",
                                            icon: (el_32 = EditRegular, createElement(el_32, {
                                                fontSize: 16,
                                            })),
                                        });
                                    },
                                    model: model,
                                    dispatch: dispatch,
                                }), createElement(DeleteTrackLevelTaskDialog, {
                                    trackLevel: trackLevel,
                                    trackLevelTask: require_1,
                                    _model: model,
                                    dispatch: dispatch,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))),
                            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])));
                        }, trackLevel.Tasks), delay(() => {
                            let elems_8;
                            return singleton(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                            }], (elems_8 = [createElement(AddCourseDialog, {
                                trackLevel: trackLevel,
                                model: model,
                                dispatch: dispatch,
                            }), createElement(AddTrackLevelTaskDialog, {
                                trackLevel: trackLevel,
                                model: model,
                                dispatch: dispatch,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
                        }))))));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])])));
}

export function TrackBuilder(trackBuilderInputProps) {
    let elems_6, elems_3, el_4, elems_2, el_8, el_14, elems_5, elems_1;
    const trackId = trackBuilderInputProps.trackId;
    const setCtx = useCtx()[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const patternInput_1 = reactApi.useState(true);
    let patternInput_2;
    const arg_1 = init();
    patternInput_2 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_2[0];
    const dispatch = patternInput_2[1];
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(Course_2.GetAllCourses());
        pr_1 = (pr.then((res) => {
            if (res.tag === 0) {
                dispatch(new Msg(2, [res.fields[0]]));
            }
            else {
                errorToast(setCtx, "getTracksError", "Kunne ikke hente kursløp", "Noe gikk galt", undefined);
            }
            return res;
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        let pr_3;
        const pr_2 = startAsPromise(Task.GetAllTasks());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 0) {
                dispatch(new Msg(10, [res_1.fields[0]]));
            }
            else {
                errorToast(setCtx, "getTasksError", "Kunne ikke hente oppgaver", "Noe gikk galt", undefined);
            }
            return res_1;
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
        if (trackId == null) {
        }
        else {
            let pr_5;
            const pr_4 = startAsPromise(Track_1.Get(trackId));
            pr_5 = (pr_4.then((res_2) => {
                if (res_2.tag === 1) {
                    errorToast(setCtx, "getTracksError", "Kunne ikke hente kursløp", "Noe gikk galt", undefined);
                }
                else {
                    dispatch(new Msg(0, [res_2.fields[0]]));
                    patternInput_1[1](false);
                }
                return res_2;
            }));
            void (pr_5.catch((ex_2) => {
                toastServerError(setCtx, ex_2);
            }));
        }
    });
    const matchValue = model_1.SelectedTrack;
    if (matchValue != null) {
        const track = matchValue;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            gap: 5 + "px ",
            width: 100 + "%",
            flexGrow: 1,
            flexDirection: "column",
        }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
            flexWrap: "wrap",
            display: "flex",
            gap: 25 + "px ",
        }], (elems_3 = [(el_4 = Subtitle1, createElement(el_4, {
            children: track.Name,
            wrap: false,
        })), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "row",
            gap: 5 + "px ",
        }], (elems_2 = [createElement(CreateCourseDialog, {
            trigger: (el_8 = Button, createElement(el_8, createObj(toList(delay(() => {
                let el_6;
                return append_1(singleton(["icon", (el_6 = AddRegular, createElement(el_6, {}))]), delay(() => append_1(singleton(["children", "Ny kursmal"]), delay(() => append_1(singleton(["appearance", "secondary"]), delay(() => {
                    const matchValue_1 = screenSize;
                    switch (matchValue_1.tag) {
                        case 0:
                        case 1:
                        case 2:
                            return singleton(["size", "medium"]);
                        default:
                            return singleton(["size", "small"]);
                    }
                }))))));
            }))))),
            callback: (course) => {
                const newCourses = append([course], model_1.Courses);
                const newTasks = append(course.Tasks, model_1.AllTasks);
                dispatch(new Msg(2, [newCourses]));
                dispatch(new Msg(10, [newTasks]));
            },
        }), createElement(AddNewTaskDialog, {
            model: model_1,
            dispatch: dispatch,
        }), createElement(EditTaskDialog, {
            renderTrigger: () => {
                let el_10;
                const el_12 = Button;
                return createElement(el_12, {
                    icon: (el_10 = EditRegular, createElement(el_10, {})),
                    iconPosition: "before",
                    appearance: "secondary",
                    size: "small",
                    disabled: model_1.AllTasks.length === 0,
                    children: "Rediger oppgave",
                });
            },
            model: model_1,
            dispatch: dispatch,
        }), (el_14 = Button, createElement(el_14, createObj(toList(delay(() => append_1(track.Enabled ? append_1(singleton(["children", "Avpubliser"]), delay(() => singleton(["style", {
            backgroundColor: tokens.colorStatusDangerForeground1,
        }]))) : singleton(["children", "Publiser"]), delay(() => append_1(singleton(["onClick", (_arg_2) => {
            let pr_7;
            const pr_6 = startAsPromise(Track_1.Update(new Track(track.Id, track.Name, track.Description, !track.Enabled, track.ImageUrl, track.Inserted, [])));
            pr_7 = (pr_6.then((res_3) => {
                if (res_3.tag === 1) {
                    if (res_3.fields[0].tag === 1) {
                        errorToast(setCtx, "updateTrackNotFound", "Kunne ikke publisere læringsløp", "Fant ikke resurs", undefined);
                    }
                    else {
                        errorToast(setCtx, "updateTrackConflict", "Noe gikk galt", "Kunne ikke publisere læringsløp", undefined);
                    }
                }
                else {
                    const r = res_3.fields[0];
                    if (r.Enabled) {
                        successToast(setCtx, `publishTrack${r.Id}Success-${track.Enabled}`, "Læringsløp publisert", "");
                    }
                    else {
                        successToast(setCtx, `publishTrack${r.Id}Success-${track.Enabled}`, "Læringsløp avpublisert", "");
                    }
                    dispatch(new Msg(0, [new Track(track.Id, track.Name, track.Description, !track.Enabled, track.ImageUrl, track.Inserted, track.TrackLevels)]));
                }
                return res_3;
            }));
            void (pr_7.catch((ex_3) => {
                toastServerError(setCtx, ex_3);
            }));
        }]), delay(() => append_1(singleton(["appearance", "primary"]), delay(() => {
            const matchValue_2 = screenSize;
            switch (matchValue_2.tag) {
                case 0:
                case 1:
                case 2:
                    return singleton(["size", "medium"]);
                default:
                    return singleton(["size", "small"]);
            }
        })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["display", "flex"]), delay(() => append_1(singleton(["flexDirection", "row"]), delay(() => {
            let matchValue_3;
            return append_1((matchValue_3 = screenSize, (matchValue_3.tag === 0) ? singleton(["flexWrap", "wrap"]) : ((matchValue_3.tag === 1) ? singleton(["flexWrap", "wrap"]) : ((matchValue_3.tag === 2) ? singleton(["flexWrap", "wrap"]) : singleton(["flexWrap", "nowrap"])))), delay(() => singleton(["gap", 15 + "px "])));
        })))))))], (elems_5 = toList(delay(() => append_1(mapIndexed((idx, tl) => createElement(TrackLevelView, {
            order: idx + 1,
            trackLevel: tl,
            _track: track,
            model: model_1,
            dispatch: dispatch,
        }), sortBy((_arg_3) => _arg_3.Order, track.TrackLevels, {
            Compare: comparePrimitives,
        })), delay(() => {
            let elems_4;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
            }], (elems_4 = [createElement(AddTrackLevelDialog, {
                trackId: track.Id,
                model: model_1,
                dispatch: dispatch,
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
    }
    else {
        return createElement("div", createObj(ofArray([["key", `${screenSize}`], ["style", {
            display: "flex",
            gap: 5 + "px ",
            height: 500,
        }], (elems_1 = toList(delay(() => (!patternInput_1[0] ? singleton(dataFetchFailedView()) : map_2((_arg_1) => {
            let elems, el;
            const el_2 = Skeleton;
            return createElement(el_2, createObj(ofArray([["style", {
                width: 400,
                height: 500,
            }], (elems = [(el = SkeletonItem, createElement(el, {
                width: 400,
                size: 128,
                shape: "rectangle",
                animation: "wave",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
        }, toList(rangeDouble(1, 1, 4)))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
}

//# sourceMappingURL=TrackBuilder.jsx.map
